<template>
  <div>
    <h3 v-if="showTitle" class="mb-5">
      Lote: <span class="text-primary">{{ plot.name }}</span> - Pre Emergencia
      <button title="Editar" class="btn btn-link btn-sm btn-fill btn-wd" @click="showEditForm">
        <i class="fas fa-pen"></i>&nbsp;Editar
      </button>
    </h3>

    <h3 v-else class="mb-4">Datos Pre-Emergencia</h3>

    <div class="row">
      <div class="col-md-6 col-sm-12">
        <p class="h5">Fecha de siembra</p>
        <p v-if="plot.preEmergence.seedDate">{{ plot.preEmergence.seedDate | date }}</p>
        <p v-else>-</p>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6 col-sm-12">
        <p class="h5">Destino de producción</p>
        <p v-if="plot.preEmergence.productionDestination">
          {{ plot.preEmergence.productionDestination.name }}
        </p>
        <p v-else>-</p>
      </div>
      <div class="col-md-6 col-sm-12">
        <p class="h5">Semillas por metro</p>
        <p v-if="plot.preEmergence.seedsPerMeter">
          {{ plot.preEmergence.seedsPerMeter }}
        </p>
        <p v-else>-</p>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6 col-sm-12">
        <p class="h4">
          Semillas por hectarea
          <span v-if="plot.groovesDistance" class="font-weight-400">
            (Distanciamiento entre surcos: {{ plot.groovesDistance | decimals }} cm.)
          </span>
          <span v-else class="text-danger small font-weight-400">
            Se debe carga la distancia entre surcos para el calculo
          </span>
        </p>
        <p>{{ plot.preEmergence.seedsPerMeter | seedsPerHectare(plot.groovesDistance) }}</p>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6 col-sm-12">
        <p class="h5">Fetilización nitrogenada <span class="text-muted">[Kg/Ha]</span></p>
        <p v-if="plot.preEmergence.nitrogenFertilization">
          {{ plot.preEmergence.nitrogenFertilization }}
        </p>
        <p v-else>-</p>
      </div>
      <div class="col-md-6 col-sm-12">
        <p class="h5">Fetilización fosfatada <span class="text-muted">[Kg/Ha]</span></p>
        <p v-if="plot.preEmergence.phosphateFertilization">
          {{ plot.preEmergence.phosphateFertilization }}
        </p>
        <p v-else>-</p>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12 col-md-6">
        <p class="h5">Control de plagas</p>
        <p v-if="plot.preEmergence.pestControl">
          {{ plot.preEmergence.pestControl }}
        </p>
        <p v-else>-</p>
      </div>
      <div class="col-sm-12 col-md-6">
        <p class="h5">Control de malezas</p>
        <p v-if="plot.preEmergence.weedControl">
          {{ plot.preEmergence.weedControl }}
        </p>
        <p v-else>-</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showTitle: {
      type: Boolean,
      default: true,
    },

    plot: {
      type: Object,
      default: () => null,
    },
  },

  methods: {
    showEditForm() {
      this.$emit('edit');
    },
  },
};
</script>
